export default __webpack_public_path__ + "static/22-high-tech-0c82549bb24c632ec8f007f6f2cdaa75.png";